import React, { useState } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useNotify } from 'react-admin';
import InviteForm from './form';
import * as Auth from '../../api';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function Invite() {
  const classes = useStyles();

  const notify = useNotify();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [submitErrors, setSubmitErrors] = useState([]);
  const [submitResponse, setSubmitResponse] = useState(null);

  const onSubmit = async (data) => {
    try {
      const response = await Auth.invite(data);
      setSubmitResponse(response.data);
      notify('Invitation email was sent');
    } catch (e) {
      const { errors } = e.response.data;
      setSubmitErrors(errors);
    }
  };

  const handleTooltipOpen = () => {
    setTooltipOpen(true);
    setTimeout(() => {
      setTooltipOpen(false);
    }, 1500)
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          Invite Providers
        </Typography>
        <InviteForm classes={classes} submitErrors={submitErrors} onSubmit={onSubmit} />
        {submitResponse && (
          <div style={{ position: 'relative' }}>
            <Paper variant="outlined" style={{ padding: 10 }}>
              {submitResponse.url}
            </Paper>
            <Tooltip
              PopperProps={{
                disablePortal: true,
              }}
              open={tooltipOpen}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title="Copied"
            >
              <CopyToClipboard text={submitResponse.url}>
                <FileCopyOutlinedIcon
                  style={{ position: 'absolute', bottom: 5, right: 5, cursor: 'pointer' }}
                  onClick={handleTooltipOpen}
                />
              </CopyToClipboard>
            </Tooltip>
          </div>
        )}
      </div>
    </Container>
  );
}
